import React from "react";
import { Alert } from "@mui/material";
import PolicyLayout, { PolicySection } from "./PolicyLayout";

export default function Legal() {
  return (
    <PolicyLayout title="Legal">
      <Alert severity="info">Draft for review. These proposed terms have not been finalized.</Alert>
      <PolicySection title="About ProspectEngage">
        ProspectEngage provides tools for economic development research, prospecting,
        outreach, and relationship management. These proposed terms describe use of
        the platform alongside your organization’s service agreement.
      </PolicySection>
      <PolicySection title="Accounts and authorized access">
        Use only an account you are authorized to access. Keep your sign-in
        credentials confidential and notify your organization’s administrator if
        you suspect unauthorized access. Your organization manages your access to
        its workspace and available features.
      </PolicySection>
      <PolicySection title="Acceptable use">
        Use the platform lawfully and respect the privacy and rights of others.
        Do not upload malicious content, attempt to bypass access controls,
        interfere with the service, or use contact information for unlawful
        outreach. Only upload or share information you have permission to use.
      </PolicySection>
      <PolicySection title="Your organization’s content">
        Your organization is responsible for the records, documents, and other
        content it adds to the platform, including their accuracy and the
        permissions needed to process them. Ownership, licensing, and handling of
        that content should be addressed in your organization’s service agreement.
      </PolicySection>
      <PolicySection title="Research, integrations, and AI features">
        Research data, third-party information, and AI-generated results may be
        incomplete or inaccurate. Verify results before relying on them for
        outreach or decisions. Connected services may have their own terms and
        privacy policies.
      </PolicySection>
      <PolicySection title="Service terms and questions">
        Refer to your organization’s executed service agreement for subscription,
        payment, availability, termination, and liability terms. Contact your
        organization’s administrator or your existing ProspectEngage contact with
        questions about access or that agreement.
      </PolicySection>
    </PolicyLayout>
  );
}
